import { FC } from 'react';

import {
  BlueRectangle,
  BlueRectangleTypography,
  IconWrapper,
  WhyChooseUsFactsDescription,
  WhyChooseUsFactsTitle,
  WhyChooseUsFactsWrapper,
  WhyChooseUsFactWrapper,
  WhyChooseUsPlatformInfo,
  WhyChooseUsPlatformLink,
  WhyChooseUsPlatformTitle,
  WhyChooseUsTitle,
  WhyChooseUsTop,
  WhyChooseUsWrapper,
} from './WhyChooseUs.styles';

import { IWhyChooseUsData } from 'types/applications';
import { ButtonsWrapper } from '../Hero/Hero.styles';
import { Button } from 'components/Buttons';
import { BOOK_A_DEMO_LINK } from 'constants/common';
import { ButtonWrapper } from 'modules/CustomerCase/Hero/Hero.styles';
import Box from '@mui/material/Box/Box';
import { Link } from 'react-router-dom';

const WhyChooseUs: FC<IWhyChooseUsData> = ({ blueBoxTitle, items, title }) => {
  return (
    <WhyChooseUsWrapper>
      <WhyChooseUsTop>
        <WhyChooseUsTitle>{title}</WhyChooseUsTitle>
        <WhyChooseUsPlatformInfo>
          <WhyChooseUsPlatformTitle>
            All applications run on the AILiveSim platform
          </WhyChooseUsPlatformTitle>
          <Link to="/platform" style={{ textDecoration: 'none' }}>
            <WhyChooseUsPlatformLink>Explore the Platform</WhyChooseUsPlatformLink>
          </Link>
        </WhyChooseUsPlatformInfo>
      </WhyChooseUsTop>

      <WhyChooseUsFactsWrapper>
        {items.map((fact, idx) => (
          <WhyChooseUsFactWrapper key={idx}>
            <IconWrapper>
              <img src={fact.imageSrc} alt={fact.title} />
            </IconWrapper>

            <WhyChooseUsFactsTitle>{fact.title}</WhyChooseUsFactsTitle>

            <WhyChooseUsFactsDescription>{fact.description}</WhyChooseUsFactsDescription>
          </WhyChooseUsFactWrapper>
        ))}
      </WhyChooseUsFactsWrapper>

      <BlueRectangle>
        <BlueRectangleTypography>
          {blueBoxTitle}
          <Box marginTop="36px">
            <ButtonsWrapper>
              <ButtonWrapper>
                <a
                  href={BOOK_A_DEMO_LINK}
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: 'none' }}
                >
                  <Button btnType="tertiary" width={240} height={56}>
                    Book a Meeting
                  </Button>
                </a>
              </ButtonWrapper>
            </ButtonsWrapper>
          </Box>
        </BlueRectangleTypography>
      </BlueRectangle>
    </WhyChooseUsWrapper>
  );
};

export default WhyChooseUs;
